import store from '@/store';

export default (to, from, next) => {
    console.log('store.getters.check', store.getters.check)
    if (!store.getters.check) {
        next()
    } else {
        next({ name: 'login' })
    }
}


// WEBPACK FOOTER //
// ./src/middleware/guest.js